module.exports = __webpack_public_path__ + "static/img/haikou-municipal-hospital.7da9251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/haikou-municipal-hospital.png
// module id = K3Db
// module chunks = 1 2